import { Link } from 'react-router-dom';
import '../styles/Footer.css';

export default function Footer() {
  return (
    <footer className="site-footer">
      <svg width="30" height="16" viewBox="0 0 60 32" fill="none" aria-hidden="true">
        <path
          d="M2 16l6 9 6-9 6 9 6-9"
          stroke="#ffffff"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>

      <div className="footer-links">
        <span>&copy; {new Date().getFullYear()} Dev Mainnet Foundation.</span>
        <Link to="/">Privacy Policy</Link>
        <Link to="/">Terms of Service</Link>
        <Link to="/">Consent Preferences</Link>
      </div>
    </footer>
  );
}